import moment from 'moment-timezone'
import { YearRange } from 'src/component-form/DateInput/DateInput'

/**
 * Year span the KYB date pickers offer. Both fields it serves — a beneficial
 * owner's date of birth and the business's date of incorporation — are always
 * in the past, and 120 years back clears the oldest plausible value for
 * either. Read per render so a session left open across New Year still offers
 * the year that just started.
 */
export function kybPastYearRange(): YearRange {
  const currentYear = moment().year()
  return { min: currentYear - 120, max: currentYear }
}
